import { ShoppingCartAnonSessionRequest } from "../../domain/ShoppingCartSlice/ShoppingCartAnonSessionRequest";
import { ShoppingCartGet } from "../../domain/ShoppingCartSlice/ShoppingCartGet";
import { ShoppingCartInsert } from "../../domain/ShoppingCartSlice/ShoppingCartInsert";
import ApiWrapperAuthenticated from "../Common/ApiWrapperAuthenticated";

export class ShoppingCartClientMeRepository 
    extends ApiWrapperAuthenticated<ShoppingCartGet, ShoppingCartInsert, ShoppingCartAnonSessionRequest, {}> {
    constructor() {
        super('clients/me/shopping-carts/');
    }
}
